import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { useRoute, useRouter, onBeforeRouteLeave } from "vue-router";
import { toRefs, defineComponent, reactive, getCurrentInstance, nextTick, computed, markRaw, watch } from "vue";
import { useStore } from "@/store/index";
import { DelayTypes, DelayStatus, ShipTypes, OrderStatus } from "@/enums/order";
import { getDelayTime } from "@/utils/index";
import { stopDeliveryApi, updateRefundSplitRateApi, getExpressInfoApi } from "@/apis/order";
import { UserMutationTypes } from "@/store/modules/user/mutation-types";
import { OrderPickStatus } from "../../enums/order";
import { CopyDocument, StarFilled } from "@element-plus/icons-vue";
import { Remove } from "@element-plus/icons-vue";
import { isValidTel, isValidMobile } from "@/utils/validator";
import ImageUploaderDialog from "@/components/ImageUploaderDialog";
export default defineComponent({
  components: {
    CopyDocument,
    StarFilled,
    Remove,
    ImageUploaderDialog
  },
  setup() {
    const {
      proxy
    } = getCurrentInstance();
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const expressInput = ref([]);
    const is_allocation = store.state.user.userInfo.is_allocation; // 针对指定商家开发自主接单功能

    const state = reactive({
      orderId: route.query.order_id,
      // 订单ID
      orderDetail: {
        // 订单详情
        express_cp: "",
        // 物流公司（配送员姓名）
        express_no: "",
        // 物流单号（配送员电话）
        phone: "",
        // 收货人电话
        originator_phone: "" //寄件人电话
      },
      productList: [],
      // 商品详情
      express_info: [
      // 每一行物流单号和公司信息的集合
      {
        express_no: "",
        express_cp: "",
        originator_phone: ""
      } // 默认第一组输入框
      ],
      tableHeight: 0,
      // table 动态高度
      chargeInfo: [],
      // 收费附件列表
      chargeSettle: 0,
      // 附件结算价
      productSettle: 0,
      // 商品结算价
      hasShop: store.state.user.userInfo.hasShop,
      // 是否为总商户
      isNotice: 0,
      noticeArray: ["该品仅限京东、顺丰发货", "该品仅限京东物流发货", "该品仅限顺丰发货"],
      displayMessage: "",
      //京东、顺丰物流分类提示
      // 延迟发货弹框
      dialogDeliveryFormVisible: false,
      currRow: {},
      // 当前操作行数据
      dialogNewExpressVisible: false,
      new_express_info: {},
      // 新增物流单号和公司信息的集合
      closingDialog: false,
      identify: "",
      phoneError: "",
      // 错误提示
      modalVisible: false,
      // 上传成品图照片、视频弹框
      currentRow: {},
      //当前操作行数据
      fileList: [],
      voucher: 0,
      expressPhoneError: "" // 快递员电话错误提示,
    });
    const disabledDate = date => {
      // 今天可选
      return date.getTime() + 1000 * 60 * 60 * 24 < Date.now();
    };
    //更改异常物流弹窗显示
    const changeExpressDialog = (express_info, index) => {
      // 当正在关闭或已关闭时不处理
      if (state.closingDialog) return;
      if (express_info.express_flag == 1) {
        state.dialogNewExpressVisible = true;
        const {
          orderId,
          new_express_info
        } = state;
        new_express_info.order_id = orderId;
        new_express_info.express_no = express_info.express_no;
        new_express_info.new_express_no = express_info.express_no;
        new_express_info.new_express_cp = express_info.express_cp;
      }
    };
    const setExpressInput = (el, index) => {
      if (el) {
        expressInput.value[index] = el; // 直接存入对应索引，避免重复 push
      }
    };
    const getCurrentInputIndex = () => {
      return state.express_info.findIndex(item => item.express_no === state.new_express_info.express_no);
    };
    const rowClassName = ({
      row
    }) => {
      if (row.status == 3) {
        return "warning-row";
      }
    };
    // 关闭异常物流弹窗
    const closeDeliveryDialog = () => {
      state.closingDialog = true; // 开始关闭流程
      state.dialogNewExpressVisible = false;
      state.identify = "";
      nextTick(() => {
        state.closingDialog = false; // DOM更新后重置标志
      });
    };
    // 保存异常物流信息
    const confirmDelivery = () => {
      // 提交物流信息
      const viewedExpresses = new Set(JSON.parse(localStorage.getItem("viewedExpresses") || "[]"));
      proxy.$http.post(`/admin/Merchant/saveExpresses`, {
        ...state.new_express_info
      }).then(res => {
        if (res.code == 200) {
          viewedExpresses.add(state.new_express_info.express_no);
          localStorage.setItem("viewedExpresses", JSON.stringify(Array.from(viewedExpresses)));
          proxy.$message({
            type: "success",
            message: res.msg
          });
          getOrderDetail();
          // **确保输入框失去焦点**
          nextTick(() => {
            const index = getCurrentInputIndex();
            if (expressInput.value[index]) {
              expressInput.value[index].blur(); // 让输入框失去焦点
            }
            // 强制将焦点移动到 body，确保输入框不会重新聚焦
            document.activeElement.blur();
          });
          state.dialogNewExpressVisible = false;
          closeDeliveryDialog();
        } else {
          proxy.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    };
    const copyOrderInfo = () => {
      const {
        orderDetail,
        chargeSettle,
        productList,
        chargeInfo
      } = state;
      // 映射产品列表并构建每个产品的详细信息字符串
      const productListDetails = productList.map(product => {
        // 使用 || 运算符来处理null、undefined和空字符串
        return `
                商品名称：${product.product_name || "无"}
                规格：${product.spec_name || "无"}
                口味：${product.tastes || "无"}
                单价：${product.price || "无"}
                数量：${product.quantity || "无"}
                商品金额：${product.price && product.quantity ? (parseFloat(product.price) * parseFloat(product.quantity)).toFixed(2) : "无"}
                结算单价：${product.clearing_price || "无"}
                罚款金额：${product.fine_price || "无"}
                罚款时间：${product.fine_at || "无"}
                罚款原因：${product.fine_remark || "无"}
            `;
      }).join("\n"); // 使用换行符连接每个产品的信息
      // 映射订单收费附件的信息
      const chargeInfoDetails = chargeInfo ? chargeInfo.map(charge => {
        return `
            名称：${charge.charge_name || "无"}
            单价 / 数量：${charge.price && charge.quantity ? charge.price + "/" + charge.quantity : "无"}
            金额：${charge.total_amount || "无"}
            `;
      }).join("\n") : "暂无收费信息";
      const orderInfo = `
        收货人姓名：${orderDetail.name || "无"}
        收货人电话：${orderDetail.phone || "无"}
        下单人电话：${orderDetail.buyer_phone || "无"}
        配送方式：${ShipTypes[orderDetail.ship_type] || "无"}
        配送时间：${orderDetail.ship_date === "0000-00-00" || ShipTypes[orderDetail.ship_type] === "快递配送" ? "" : `${orderDetail.ship_date}    `}${orderDetail.ship_time_text || "无"}
        收货人地址：${orderDetail.province && orderDetail.city && orderDetail.area && orderDetail.addr ? orderDetail.province + " " + orderDetail.city + " " + orderDetail.area + " " + orderDetail.addr : "无"}
        用户备注：${orderDetail.buyer_msg || "无"}
        订单号：${orderDetail.order_no || "无"}
        额外配件费：${orderDetail.fitting_fee || "无"}
        附件结算价：${chargeSettle ? chargeSettle.toFixed(2) : "无"}
        商品信息：${productListDetails}
        收费附件：${chargeInfoDetails}
        `;
      navigator.clipboard.writeText(orderInfo).then(() => {
        proxy.$message({
          type: "success",
          message: "复制成功"
        });
      }).catch(err => {
        proxy.$message({
          type: "error",
          message: err
        });
      });
    };
    // 获取订单详情
    const getOrderDetail = () => {
      proxy.$http.get(`/admin/merchant/edit?order_id=${state.orderId}`).then(res => {
        const {
          code,
          data,
          msg
        } = res;
        if (code != 0) {
          return proxy.$message({
            type: "error",
            message: msg
          });
        }
        state.orderDetail = data.orderInfo[0];
        state.isSave = data.is_shipment;
        state.voucher = data.voucher;
        //获取详情添加的物流信息
        data.orderInfo.forEach(order => {
          // 判断是否有初始物流信息
          order.hasInitialExpressInfo = order.express_info && order.express_info.length > 0;

          // 如果物流信息为空，则为其添加一个默认的空对象
          if (!order.express_info || order.express_info.length === 0) {
            order.express_info = [{
              express_no: "",
              express_cp: "",
              originator_phone: ""
            }];
          }
        });
        state.productList = data.orderInfo;
        state.chargeInfo = data.chargeInfo;
        // 附件结算价计算（附件总金额+额外配件费）
        let chargeSettle = parseFloat(state.orderDetail.fitting_fee);
        if (state.chargeInfo) {
          state.chargeInfo.map(item => {
            chargeSettle += parseFloat(item.total_amount);
          });
          state.chargeSettle = chargeSettle;
        }
        // 商品结算价
        let productSettle = 0;
        state.productList.map(item => {
          productSettle += parseFloat(item.clearing_price * item.quantity);
          item.canCancel = item.express_cp && item.express_no;
        });
        state.productSettle = productSettle;

        // 退款信息
        state.orderDetail.refundInfo = data.product_bear && data.product_bear[0];
      });
    };
    // 添加新的输入框
    const addField = express_info => {
      express_info.push({
        express_no: "",
        express_cp: "",
        originator_phone: ""
      });
    };
    // 删除指定输入框
    const removeField = (express_info, index) => {
      express_info.splice(index, 1);
    };
    // 获取物流公司信息，根据对应行的输入框显示
    const getExpressInfo = async express_info => {
      const {
        express_no
      } = express_info;
      if (!express_no) {
        express_info.express_cp = "";
        express_info.disabled = false;
        return;
      }
      try {
        const {
          code,
          data,
          msg
        } = await getExpressInfoApi(express_no);
        if (code == 200) {
          // 更新当前 field 的物流公司信息
          express_info.express_cp = data.current_express_no;
          express_info.disabled = true;
        } else {
          proxy.$message({
            type: "error",
            message: msg
          });
          express_info.disabled = false;
          express_info.express_cp = "";
        }
      } catch (error) {
        proxy.$message({
          type: "error",
          message: error.message || '获取物流信息失败'
        });
        express_info.disabled = false;
        express_info.express_cp = "";
      }
      state.closingDialog = false;
    };
    // 手机号输入时过滤非数字
    const handleInput = (event, expressInfo) => {
      const rawValue = event;
      const cleanValue = rawValue.replace(/[^\d-]/g, "");
      expressInfo.originator_phone = cleanValue;
      event = cleanValue;
      state.phoneError = "";
    };
    // 失焦时手机号
    const validatePhone = expressInfo => {
      const ship_flag = ShipTypes[state.orderDetail.ship_type] === "快递配送";
      if (ship_flag && expressInfo.originator_phone != "") {
        if (!isValidTel(expressInfo.originator_phone) && !isValidMobile(expressInfo.originator_phone)) {
          state.phoneError = "手机号或者座机格式错误,例如：13888888888或010-12345678";
        }
      }
    };
    const validateExpressPhone = phone => {
      if (phone != "") {
        if (!isValidTel(phone) && !isValidMobile(phone)) {
          state.expressPhoneError = "手机号或者座机格式错误,例如：13888888888或010-12345678";
        } else {
          state.expressPhoneError = "";
        }
      }
    };
    const getNewExpressInfo = async express_info => {
      const {
        new_express_no
      } = express_info;
      if (!new_express_no) {
        express_info.express_cp = "";
        express_info.disabled = false;
        return;
      }
      try {
        const {
          code,
          data,
          msg
        } = await getExpressInfoApi(new_express_no);
        if (code != 200) {
          state.identify = 1;
          state.new_express_info.new_express_cp = "";
          state.new_express_info.disabled = false;
          return proxy.$message({
            type: "error",
            message: msg
          });
        }

        // 更新当前 field 的物流公司信息
        state.new_express_info.new_express_cp = data.current_express_no;
        state.new_express_info.disabled = true;
        state.identify = 1;
        // if(state.new_express_info.new_express_no != express_info.express_no){
        //     confirmDelivery()
        // }
      } catch (error) {
        state.new_express_info.new_express_cp = "";
        state.new_express_info.disabled = false;
        proxy.$message({
          type: "error",
          message: error
        });
      }
    };
    // 保存单个商品物流信息
    const onSaveItem = row => {
      const {
        order_id,
        item_id,
        express_info,
        label_name,
        ship_type
      } = row;

      // 初始化校验标志
      let isValid = true;
      const ship_flag = ShipTypes[state.orderDetail.ship_type] === "快递配送";
      let info_flag = false;
      // 遍历 express_info 数组
      express_info.forEach((info, index) => {
        const {
          express_cp,
          express_no,
          originator_phone
        } = info;

        // if(ship_flag){
        //     info_flag = !express_cp || !express_no || !originator_phone
        //     if(state.phoneError){
        //         isValid = false;
        //         return;
        //     }
        // }else{
        info_flag = !express_cp || !express_no;
        // }
        if (info_flag) {
          proxy.$message({
            type: "error",
            message: `请填写第 ${index + 1} 条物流信息必填项`
          });
          isValid = false; // 校验失败
          return; // 停止当前循环项的处理
        }

        // 检查是否包含京东或顺丰
        const containsJD = label_name === null || label_name === void 0 ? void 0 : label_name.includes("京东");
        const containsSF = label_name === null || label_name === void 0 ? void 0 : label_name.includes("顺丰");

        // 根据是否包含京东或顺丰进行判断
        if (ship_type === "same") {
          state.isNotice = containsJD && containsSF ? 1 : containsJD ? 2 : containsSF ? 3 : 0;
        }

        // 判断当前物流公司输入是否符合要求
        if (state.isNotice === 1 && !express_cp.includes("京东") && !express_cp.includes("顺丰") || state.isNotice === 2 && !express_cp.includes("京东") || state.isNotice === 3 && !express_cp.includes("顺丰")) {
          info.displayMessage = state.isNotice > 0 ? state.noticeArray[state.isNotice - 1] : "";
          isValid = false; // 校验失败
          return; // 停止当前循环项的处理
        } else {
          info.displayMessage = ""; // 清除错误提示
        }
      });

      // 如果校验失败，直接返回，避免请求接口
      if (!isValid) {
        return;
      }

      // 提交物流信息
      proxy.$confirm("确定要修改当前商品物流信息？", "提示", {
        type: "warning"
      }).then(() => {
        proxy.$http.post(`/admin/merchant/add_express`, {
          order_id,
          item_id,
          express_info
        }).then(res => {
          if (res.code == 200) {
            proxy.$message({
              type: "success",
              message: res.msg
            });
            getOrderDetail();

            // 如果当前订单已没有未处理商品，菜单提醒数字减一
            if (res.data.unSolveOrder == 0) {
              store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, "unSolveOrder");
            }
          } else {
            proxy.$message({
              type: "error",
              message: res.msg
            });
          }
        });
      }).catch(() => {
        console.log("取消物流信息保存");
      });
    };
    // 取消发货
    const onCancel = item_id => {
      proxy.$confirm("确定要取消发货吗？", "提示", {
        type: "warning"
      }).then(() => {
        stopDeliveryApi(item_id).then(res => {
          const {
            code,
            data,
            msg
          } = res;
          if (code != 200) {
            return proxy.$message({
              type: "error",
              message: msg
            });
          }
          proxy.$message({
            type: "success",
            message: "取消发货成功"
          });
          getOrderDetail();
        });
      }).catch(() => {
        console.log("取消操作");
      });
    };
    // 设置 table 调试
    const setTableHeight = () => {
      nextTick(() => {
        let headerHeight = 50,
          // 头部高度
          mainPadding = 40,
          // 主内容区上下内边距
          titleHeight = proxy.$refs.titleRef.$el.offsetHeight,
          // 模块标题栏 * 2
          summaryHeight = proxy.$refs.summaryRef.$el.offsetHeight,
          // 配送信息总览
          totalHeight = proxy.$refs.totalRef.$el.offsetHeight; // 底部总计栏
        state.tableHeight = window.innerHeight - headerHeight - mainPadding - titleHeight * 2 - summaryHeight - totalHeight;
      });
    };

    // 打开延迟发货弹框
    const openDelayDialog = row => {
      state.currRow.item_id = row.item_id;
      state.currRow.paid_at = row.paid_at;
      state.currRow.delay_delivery_type = "";
      state.currRow.delay_delivery_time = "";
      state.currRow.delay_reson = "";
      state.dialogDeliveryFormVisible = true;
      nextTick(() => {
        proxy.$refs["addDeliveryForm"].clearValidate();
      });
    };
    /*
        由于双向绑定数据驱动视图原因，（不用v-model双向绑定的值进行判断）
        canCancel根据物流信息和物流单号总体进行判断
        3.根据订单下的商品进行状态的判断
            订单已部分发货，请到详情页进行操作（reject_status！==3（已驳回）时，）
        1.支付时间超48h不支持延迟发货
        预售商品判断（以下两条仅为预售商品的判断，其余以上条件包含全部商品）
            1.预售期间不支持延迟发货（包含预售开始结束当天23:59:59）
            2.预售结束时间超48h不支持延迟发货
     */
    //根据商品判断不可选延迟发货提醒情况
    const onTips = row => {
      if (row.status == 3) {
        return "该商品已退款";
      } else if (Boolean(row.canCancel)) {
        return "当前状态不可操作";
      } else if (row.reject_status === 0) {
        return "延迟发货申请正在审核";
      } else if (row.reject_status == 1) {
        return "延迟发货申请已通过";
      } else if (!row.yushou_end_date && Date.now() - new Date(row.paid_at).getTime() > 1000 * 60 * 60 * 48) {
        return "支付时间超48h不支持延迟发货";
      } else if (row.yushou_end_date && Date.now() <= new Date(row.yushou_end_date + " 23:59:59 ").getTime()) {
        return "预售期间不支持延迟发货";
      } else if (row.yushou_end_date && Date.now() >= new Date(row.yushou_end_date + " 23:59:59 ").getTime() + 1000 * 60 * 60 * 48) {
        return "预售结束时间超48h不支持延迟发货";
      }
    };
    // 延迟发货请求
    const onDelaySave = () => {
      proxy.$refs["addDeliveryForm"].validate(valid => {
        if (valid) {
          const {
            item_id,
            delay_delivery_type,
            delay_delivery_time,
            delay_reson
          } = state.currRow;
          proxy.$http.post(`/admin/merchant/delay_delivery_sigle`, {
            item_id,
            delay_delivery_type,
            delay_delivery_time,
            delay_reson
          }).then(res => {
            if (res.code != 200) {
              return proxy.$message({
                type: "error",
                message: res.msg
              });
            }
            proxy.$message({
              type: "success",
              message: "操作成功"
            });

            // 如果当前订单已没有未处理商品，菜单提醒数字减一
            if (res.data.unSolveOrder == 0) {
              store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, "unSolveOrder");
            }
            state.dialogDeliveryFormVisible = false;
            getOrderDetail();
          });
        }
      });
    };
    // 关闭延迟发货弹框前清空数据
    const beforeDelayDialogClose = () => {
      state.currRow = {};
      state.dialogDeliveryFormVisible = false;
    };
    /**
     *  设置 商品无货、其他 状态下，可选延迟发货时间列表
     *  商品无货情况下，延迟发货只能选择 支付时间 + 48小时 + 30 的时间，即[30]
     *  其他情况下，延迟发货只能选择 支付时间 + 30 的时间，即[30]
     * */
    const selectableTimeList = computed(() => {
      const {
        paid_at,
        delay_delivery_type
      } = state.currRow;
      let dateArr = [];
      if (delay_delivery_type == DelayTypes["商品无货"] || delay_delivery_type == DelayTypes["其他"]) {
        dateArr = [2, 3, 4, 5, 6, 7];
      }
      // 将 paid_at 转换为 Date 对象
      let paidAtDate = new Date(paid_at);

      // 提取 paid_at 的年、月、日，并将时、分、秒设为 23:59:59
      let stopTime = `${paidAtDate.getFullYear()}-${String(paidAtDate.getMonth() + 1).padStart(2, "0")}-${String(paidAtDate.getDate()).padStart(2, "0")} 23:59:59`;
      let timeList = dateArr.map(item => getDelayTime(stopTime, item));
      return timeList;
    });
    // 校验延迟类型
    const validDelayType = (rule, val, callback) => {
      if (val == 0) {
        callback(new Error("请选择延迟发货类型"));
      } else {
        callback();
      }
    };
    // 校验延迟时间
    const validDelayTime = (rule, val, callback) => {
      if (val == "0000-00-00 00:00:00") {
        callback(new Error("请选择延迟发货类型"));
      } else {
        callback();
      }
    };
    // 延迟发货弹框表单校验
    const deliveryRules = reactive({
      delay_delivery_type: [{
        required: true,
        message: "请选择延迟发货类型",
        trigger: "change"
      }, {
        validator: validDelayType,
        trigger: "change"
      }],
      delay_delivery_time: [{
        required: true,
        message: "请选择延迟发货时间",
        trigger: "change"
      }, {
        validator: validDelayTime,
        trigger: "change"
      }],
      delay_reson: [{
        required: true,
        message: "请填写延迟发货原因",
        trigger: "blur"
      }]
    });

    // 修改退款分担金额
    const updateRefundInfo = async () => {
      const {
        platform_bear,
        business_bear
      } = state.orderDetail.refundInfo;
      const {
        total_amount
      } = state.orderDetail;
      if (Number(platform_bear) + Number(business_bear) != Number(total_amount)) {
        return proxy.$message({
          type: "error",
          message: "退款分担金额之和必须等于订单总金额"
        });
      }
      const {
        code,
        data,
        msg
      } = await updateRefundSplitRateApi(state.orderDetail.order_no, platform_bear, business_bear);
      if (code != 200) return proxy.$message({
        type: "error",
        message: msg
      });
      proxy.$message({
        type: "success",
        message: "修改成功"
      });
      router.go(-1);
    };

    // 设置 table 高度
    setTableHeight();
    // 监听窗口变化，重置 table 高度
    window.onresize = setTableHeight;
    // 注销 onresize 监听
    onBeforeRouteLeave(() => {
      window.onresize = null;
    });
    getOrderDetail();

    //监听异常物流单号变化
    watch(() => state.new_express_info.new_express_no, (newVal, oldVal) => {
      if (newVal) {
        state.identify = "";
      }
    });
    watch(() => state.voucher, (newVal, oldVal) => {
      if (newVal == 1) {
        proxy.$http.get(`/port/orders/get_delivery_voucher?id=${state.orderDetail.order_id}`).then(res => {
          const {
            code,
            data,
            msg
          } = res;
          if (code != 200) {
            return proxy.$message({
              type: "error",
              message: msg
            });
          }
          let fileList = [...(Array.isArray(data.img) ? data.img.map(url => ({
            url,
            type: "image/jpg",
            raw: {
              type: "image/jpg"
            }
          })) : []), ...(Array.isArray(data.video) ? data.video.map(url => ({
            url,
            type: "video/mp4"
          })) : [])];
          state.fileList = fileList;
        });
      } else {
        state.fileList = [];
      }
    });
    const openUploader = row => {
      state.currentRow = state.orderDetail;
    };
    return {
      ...toRefs(state),
      rowClassName,
      store,
      is_allocation,
      DelayTypes,
      DelayStatus,
      onTips,
      ShipTypes,
      OrderStatus,
      OrderPickStatus,
      getOrderDetail,
      onSaveItem,
      openDelayDialog,
      onDelaySave,
      beforeDelayDialogClose,
      selectableTimeList,
      deliveryRules,
      disabledDate,
      copyOrderInfo,
      onCancel,
      updateRefundInfo,
      getExpressInfo,
      addField,
      removeField,
      changeExpressDialog,
      closeDeliveryDialog,
      confirmDelivery,
      getNewExpressInfo,
      setExpressInput,
      getCurrentInputIndex,
      handleInput,
      validatePhone,
      openUploader,
      validateExpressPhone
    };
  }
});